import "core-js/modules/es.array.find";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { parseTemplate } from '@/util';
export default {
  data: function data() {
    return {
      curStar: 'all'
    };
  },
  computed: {
    configList: function configList() {
      var list = window.setting.道具配置.明星列表;
      return list.sort(function (a, b) {
        var i = a.排序 || 0;
        var j = b.排序 || 0;
        return i - j;
      });
    },
    fansRanks: function fansRanks() {
      return this.$store.state.fansRanks || {};
    },
    theMostLikeStar: function theMostLikeStar() {
      return this.$store.getters.theMostLikeStar || {};
    },
    supportList: function supportList() {
      return this.$store.state.supportList || [];
    },
    curList: function curList() {
      return this.fansRanks[this.curStar] || [];
    },
    curStarInfo: function curStarInfo() {
      var _this = this;

      return this.starList.find(function (star) {
        return "".concat(star.id) === "".concat(_this.curStar);
      });
    },
    voteInfo: function voteInfo() {
      var voteInfo = this.$store.state.voteInfo;
      return voteInfo[this.curStar];
    },
    notice: function notice() {
      var _this2 = this,
          _list$,
          _list$2,
          _list$3;

      var noticeConfig = window.setting.道具配置.粉丝总榜公告;

      if (this.curStar !== 'all') {
        var item = this.starList.find(function (star) {
          return star.id === _this2.curStar;
        });

        if (item) {
          noticeConfig = item.分榜公告;
        }
      }

      var list = this.fansRanks[this.curStar] || [];
      var data = {
        n1: this.hideNick((_list$ = list[0]) === null || _list$ === void 0 ? void 0 : _list$.fansName),
        n2: this.hideNick((_list$2 = list[1]) === null || _list$2 === void 0 ? void 0 : _list$2.fansName),
        n3: this.hideNick((_list$3 = list[2]) === null || _list$3 === void 0 ? void 0 : _list$3.fansName)
      };
      var notice = parseTemplate(noticeConfig.截止前, data);

      if (this.isPropsEnd) {
        notice = parseTemplate(noticeConfig.截止后, data) || notice;
      }

      return notice;
    }
  },
  methods: {
    select: function select(id) {
      this.curStar = id;
      this.refreshRankBySelect();
    },
    getFansDesc: function getFansDesc(key) {
      var _this3 = this;

      var nameKey = '明星剧名';
      var name = this.curStarInfo && this.curStarInfo[nameKey];

      if (key === 'my') {
        if (this.curStar === 'all') {
          name = this.theMostLikeStar && this.theMostLikeStar[nameKey];
        } else {
          var star = this.supportList.find(function (star) {
            return star.id === _this3.curStar;
          });

          if (!star) {
            name = '';
          }
        }
      } else if (this.curStar === 'all') {
        // 总榜显示
        var _star = this.starList.find(function (star) {
          return star.id === key;
        });

        name = _star ? _star[nameKey] : '';
      }

      return name ? "".concat(name, "\u7684\u5C0F\u4F7F\u5F92") : '小使徒';
    },
    bindEvent: function bindEvent() {
      var _this4 = this;

      this.eventBus.$on('refreshRank', function (params) {
        _this4.refreshRank(params);
      });
    },
    refreshRankBySelect: function refreshRankBySelect() {
      var id = this.curStar === 'all' ? null : this.curStar;
      var voteInfo = this.$store.state.voteInfo;
      this.$store.dispatch('getFansRanks', id);

      if (id && !voteInfo[id]) {
        this.$store.dispatch('getMyVoteInfo', {
          recipientID: id,
          recipientType: 4
        });
      }
    },
    refreshRank: function refreshRank() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      // 如果当前分榜是用户送魂力的明星的分榜，刷新
      if (this.curStar === params.id) {
        this.$store.dispatch('getFansRanks', params.id);
      } else if (this.curStar === 'all') {
        // 当前tab是总榜，刷新
        this.$store.dispatch('getFansRanks');
      } // 刷新用户总的支持列表和对应分榜的排名


      this.$store.dispatch('getMyVoteInfo');
      this.$store.dispatch('getMyVoteInfo', {
        recipientID: params.id,
        recipientType: 4
      });
    },
    bulletinClick: function bulletinClick() {
      if (this.isPropsEnd) {
        this.eventBus.$emit('showFansListPop');
      }
    }
  },
  mounted: function mounted() {
    this.bindEvent();
  }
};